// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "EditLink-module--bx--text-truncate--end--1AAC8";
export var bxTextTruncateFront = "EditLink-module--bx--text-truncate--front--22DUg";
export var link = "EditLink-module--link--evBpU";
export var row = "EditLink-module--row--1Bhkt";